import React, { useState, useEffect, useRef } from "react";
import "./mobile.css";

import swipeIcon from "./../../logos/Menu.png";
import callPiggybackAPI from "../TruInk/Helpers/piggyback.api.helper";

import { useSwipeable } from "react-swipeable";
import TruinkMobileDock from "./truinkMobileDock";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import RecordDetailsModal from "./dataRecordTable";
import AppsIcon from '@mui/icons-material/Apps';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import { MobileViewCollectionModal } from "./MobileViewCollectionModal";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import BrushIcon from '@mui/icons-material/Brush';
import TrueInkCollectionProfileModal from "../TruInk/Components/TruInkCollectionPrintModel";
import { toast } from "react-toastify";
import { MobileViewDataModal } from "./MobileViewDataModal";
import {
  Box,
  Typography,
  IconButton,
  TextField,
  InputAdornment,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  ListItemIcon
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";
import { setLogoutUser } from "../../redux/slices/userSlice";
import { setLogout } from "../../redux/slices/authSlice";



function MobileMain({ mac, siteData = {}, onMacChange }) {
  const dispatch = useDispatch();
  // header account menu + logout confirmation
  const [accountMenuAnchor, setAccountMenuAnchor] = useState(null);
  const [logoutConfirmOpen, setLogoutConfirmOpen] = useState(false);

  const handleAccountMenuOpen = (e) => setAccountMenuAnchor(e.currentTarget);
  const handleAccountMenuClose = () => setAccountMenuAnchor(null);

  const handleLogoutRequest = () => {
    handleAccountMenuClose();
    setLogoutConfirmOpen(true);
  };

  const handleLogoutConfirm = () => {
    dispatch(setLogoutUser());
    dispatch(setLogout());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setLogoutConfirmOpen(false);
  };

  // search + suggestion state
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [isDishSelected, setIsDishSelected] = useState(false);
  const [collections, setCollections] = useState([]);
  const [selectedCollecion, setSelectedCollection] = useState({})

  // UI message { type: info | success | error, text: string }
  const [uiMessage, setUiMessage] = useState({ type: "", text: "" });

  // binding + site/tenant + digitalTag
  const [bindingData, setBindingData] = useState(null);
  const [isBindingLoading, setIsBindingLoading] = useState(false);
  const [siteId, setSiteId] = useState("");
  const [tenantId, setTenantId] = useState("");

  // records fetched from API (full objects)
  const [allItems, setAllItems] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isDataSelectorActive, setIsDataSelectorActive] = useState(true);
  const [isTemplateSelectorActive, setIsTemplateSelectorActive] =
    useState(false);
  const [templateSearchTerm, setTemplateSearchTerm] = useState("");
  const [templateSuggestions, setTemplateSuggestions] = useState([]);
  const [isTemplateInputSelected, setIsTemplateInputSelected] = useState(false);
  const [templateDropdownOpen, setTemplateDropdownOpen] = useState(true);
  const dataInputRef = useRef(null);
  const swipeButtonRef = useRef(null);
  const formSwipeButtonRef = useRef(null);
  const suppressSuggestionsRef = useRef(false);
  const [active, setActive] = useState(-1)
  // Swipe visuals
  const [swipeThumbOffset, setSwipeThumbOffset] = useState(0);
  // UI / request states for bind/refresh
  const [isBindingRequestRunning, setIsBindingRequestRunning] = useState(false);
  const [isRefreshRunning, setIsRefreshRunning] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const hasPromptedRef = useRef(false);

  // Swipe progress state for visual feedback
  const [swipeProgress, setSwipeProgress] = useState(0);
  const [formSwipeProgress, setFormSwipeProgress] = useState(0);
  const [formSwipeThumbOffset, setFormSwipeThumbOffset] = useState(0);

  const [showTagSearch, setShowTagSearch] = useState(false);
  const [tagSearchTerm, setTagSearchTerm] = useState("");
  const [tagSearchResults, setTagSearchResults] = useState([]);
  const [isTagSearchLoading, setIsTagSearchLoading] = useState(false);
  const tagSearchDebounceRef = useRef(null);
  const [dataTableOpen, setDataTableOpen] = useState(false)
  const [collectionsTableOpen, setCollectionTableOpen] = useState(false)
  const [selectedCollectionProfile, setSelectedCollectionProfile] = useState({})
  const [selectedRecordForView, setSelectedRecordForView] = useState({})
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Advanced toggle (persist in localStorage)
  const [advancedMode, setAdvancedMode] = useState(() => {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        const stored = window.localStorage.getItem("mobile_advanced");
        if (stored !== null) return stored === "true";
      }
    } catch (e) {
      // ignore
    }
    return false;
  });

  useEffect(() => {
    try {
      if (typeof window !== "undefined" && window.localStorage) {
        window.localStorage.setItem(
          "mobile_advanced",
          advancedMode ? "true" : "false",
        );
      }
    } catch (e) {
      // ignore
    }
  }, [advancedMode]);

  // Add-Dish flow state
  const [showAddForm, setShowAddForm] = useState(false);
  const [newSiteData, setNewSiteData] = useState({});
  const [dataInfoList, setDataInfoList] = useState(null);
  const [currentDataInfo, setCurrentDataInfo] = useState(null);
  const [schemaFields, setSchemaFields] = useState([]);
  const dataInfoFetchKeyRef = useRef("");
  const isDataInfoFetchingRef = useRef(false);

  const handleAddClick = () => {
    if (!advancedMode) return;
    const identifier = searchTerm || "";
    // initialize form data with provided siteData shape, prefer search term
    setNewSiteData({ identifier, dishName: identifier, ...siteData });
    setSchemaFields(Object.keys(siteData || {}));
    setShowAddForm(true);
  };

  // When opening the form, fetch available data-info schemas for this site
  useEffect(() => {
    let isMounted = true;
    const fetchDataInfo = async () => {
      if (!showAddForm || !siteId || !tenantId) return;
      const fetchKey = `${tenantId}:${siteId}`;
      if (
        isDataInfoFetchingRef.current ||
        dataInfoFetchKeyRef.current === fetchKey
      ) {
        return;
      }

      isDataInfoFetchingRef.current = true;
      try {
        const list = await callPiggybackAPI(
          "data-info",
          { tenantId, siteId },
          {},
          "GET",
        );
        if (!isMounted) return;
        dataInfoFetchKeyRef.current = fetchKey;
        setDataInfoList(Array.isArray(list) ? list : []);
        const first = Array.isArray(list) && list.length > 0 ? list[0] : null;
        setCurrentDataInfo(first);
        if (first && first.fields) {
          setSchemaFields(Object.keys(first.fields));
        } else {
          setSchemaFields(Object.keys(siteData || {}));
        }
      } catch (err) {
        setDataInfoList([]);
        setCurrentDataInfo(null);
        setSchemaFields(Object.keys(siteData || {}));
      } finally {
        isDataInfoFetchingRef.current = false;
      }
    };

    fetchDataInfo();
    return () => (isMounted = false);
  }, [showAddForm, siteId, tenantId]);

  const handleFormChange = (key, value) => {
    setNewSiteData((prev) => ({ ...prev, [key]: value }));
  };

  const handleFormCancel = () => {
    setShowAddForm(false);
    dataInfoFetchKeyRef.current = "";
    isDataInfoFetchingRef.current = false;
  };

  const handleFormSave = async () => {
    // Save via API (data-record) if possible, otherwise local fallback
    return new Promise((resolve) => {
      const save = async () => {
        if (siteId && tenantId && currentDataInfo) {
          const values = Object.keys(newSiteData || {}).reduce((acc, key) => {
            if (key === "identifier") return acc;
            acc[key] = newSiteData[key];
            return acc;
          }, {});

          const body = {
            ...(selectedRecord?.id && !selectedRecord.id.startsWith("new-") && { id: selectedRecord.id }),
            tenantId,
            siteId,
            dataInfoId: currentDataInfo.id,
            values,
            identifier: newSiteData.dishName || newSiteData.identifier,
            recordedAt: new Date().toISOString(),
            customProperties: {},
          };


          try {
            const apiResp = await callPiggybackAPI(
              "data-record",
              {},
              body,
              "POST",
            );

            if (apiResp) {
              const newItem = {
                id: apiResp.id || `new-${Date.now()}`,
                identifier: newSiteData.dishName || newSiteData.identifier || "",
                values: newSiteData,
              };

              // Check if we're updating an existing record or creating a new one
              const isUpdating = selectedRecord?.id && !selectedRecord.id.startsWith("new-");

              if (isUpdating) {
                // Update existing item in the list
                setAllItems((prev) =>
                  prev.map((item) =>
                    item.id === selectedRecord.id ? newItem : item
                  )
                );
              } else {
                // Add new item to the list
                setAllItems((prev) => [newItem, ...prev]);
              }

              setSelectedRecord(newItem);
              setUiMessage({ type: "success", text: "Record updated." });
              setIsDishSelected(true);
              setSearchTerm(newSiteData.identifier || newSiteData.dishName || "");
              setShowAddForm(false);
              dataInfoFetchKeyRef.current = "";
              isDataInfoFetchingRef.current = false;
              resolve(newItem);
              return;
            }
          } catch (err) {
            console.error("Failed to save data-record:", err);
            setUiMessage({
              type: "error",
              text: "Save failed. Please check your input and try again.",
            });
            resolve(null);
            return;
          }
        } else {
          setUiMessage({
            type: "error",
            text: "Missing required site or tenant information.",
          });
          resolve(null);
          return;
        }
        resolve(null);
      };

      save();
    });
  };

  const handleFormSaveAndBrush = async () => {
    const savedItem = await handleFormSave();
    if (!savedItem) return;
    try {
      const dynamicDataId = savedItem.id;
      if (dynamicDataId && !dynamicDataId.startsWith("new-") && bindingData?.digitalTagId) {

        const payload = {
          tenantId,
          siteId,
          digitalTagIds: [bindingData.digitalTagId],
          dynamicDataId,
          templateId: selectedTemplate?.id || bindingData?.templateId,
        };
        await callPiggybackAPI("digitalTag/bindTemplateData", {}, payload, "POST");
      }
      await refreshDigitalTagNow();
    } catch (e) {
      console.error("Bind/refresh after form save failed:", e);
    }
  };

  const handleFormSaveAndCancel = async () => {
    const updatedData = {
      ...newSiteData,
      identifier: newSiteData.dishName || newSiteData.identifier,
    };

    setNewSiteData(updatedData);
    const saveSuccess = await handleFormSave();
    if (!saveSuccess) return;
    // Reset selectedRecord so the card shows the old tag-bound name (bindingData.dataRecordName)
    // since we saved data changes but did NOT update the tag binding
    suppressSuggestionsRef.current = true;
    setSelectedRecord(null);
    setIsDishSelected(false);
    setSearchTerm("");
    setSuggestions([]);
    setShowAddForm(false);
    dataInfoFetchKeyRef.current = "";
    isDataInfoFetchingRef.current = false;
  };

  const handleCancelAndBrush = async () => {
    setShowAddForm(false);
    dataInfoFetchKeyRef.current = "";
    isDataInfoFetchingRef.current = false;
    try {
      await refreshDigitalTagNow();
    } catch (e) {
      // ignore
    }
  };


  const handleTagSearchChange = async (e) => {
    const value = e.target.value;
    setTagSearchTerm(value);
    setTagSearchResults([]);

    if (tagSearchDebounceRef.current) clearTimeout(tagSearchDebounceRef.current);
    if (!value.trim()) return;

    tagSearchDebounceRef.current = setTimeout(async () => {
      setIsTagSearchLoading(true);
      try {
        const results = await callPiggybackAPI(
          "getTagByName",
          { name: value.trim(), tenantId },
          {},
          "GET"
        );
        setTagSearchResults(Array.isArray(results) ? results : []);
      } catch {
        setTagSearchResults([]);
      } finally {
        setIsTagSearchLoading(false);
      }
    }, 400);
  };

  const handleTagSelect = (tag) => {
    if (tag?.siteId) {
      setSiteId(tag?.siteId)
    }

    setShowTagSearch(false);
    setTagSearchTerm("");
    setTagSearchResults([]);
    if (onMacChange) onMacChange(tag.macAddress.toLowerCase());
  };

  const openTagSearch = (val) => {
    setShowTagSearch(val);
    setTagSearchTerm("");
    setTagSearchResults([]);
  };

  const closeTagSearch = () => {
    setActive(-1)
    setShowTagSearch(false);
    setTagSearchTerm("");
    setTagSearchResults([]);
    if (tagSearchDebounceRef.current) clearTimeout(tagSearchDebounceRef.current);
  };


  useEffect(() => {
    let isMounted = true;

    if (!mac)
      setUiMessage({
        type: "error",
        text: "Please provide a valid MAC address.",
      });
    const fetchBindingData = async () => {
      if (!mac) return;
      setIsBindingLoading(true);

      try {
        const response = await callPiggybackAPI(
          "getTagDatabindingbyMacAddress",
          { macAddress: mac },
          {},
          "GET",
        );

        if (!isMounted) return;

        setBindingData(response || null);
        if (response?.siteId) setSiteId(response.siteId);
        if (response?.tenantId) setTenantId(response.tenantId);
      } catch (err) {
        const status = err?.response?.status;
        if (status === 401 || status === 403) {
          setUiMessage({
            type: "error",
            text: "You are not authorized to access this tag.",
          });
        } else {
          setUiMessage({
            type: "error",
            text: "Unable to fetch tag info. Try again.",
          });
        }
        setBindingData(null);
      } finally {
        if (isMounted) setIsBindingLoading(false);
      }
    };

    fetchBindingData();
    return () => (isMounted = false);
  }, [mac]);

  useEffect(() => {
    const fetchItemsAndTemplates = async () => {
      if (!siteId || !tenantId) return;

      try {
        const [dataResponse, templateResponse, collectionsResponse] = await Promise.all([
          callPiggybackAPI("data-record", { siteId, tenantId }, {}, "GET"),
          callPiggybackAPI("templates", { siteId, tenantId }, {}, "GET"),
          callPiggybackAPI("collections", { siteId, tenantId }, {}, "GET"),
        ]);

        setAllItems(Array.isArray(dataResponse) ? dataResponse : []);
        setTemplates(Array.isArray(templateResponse) ? templateResponse : []);
        setCollections(Array.isArray(collectionsResponse) ? collectionsResponse : []);
      } catch (err) {
        setAllItems([]);
        setTemplates([]);
        setCollections([]);
        setUiMessage({
          type: "error",
          text: "Unable to load menu or template items.",
        });
      }
    };

    fetchItemsAndTemplates();
  }, [siteId, tenantId]);

  // Keep template selection aligned with binding data
  useEffect(() => {
    if (bindingData?.templateId) {
      setSelectedTemplate((prev) => {
        if (prev?.id === bindingData.templateId) return prev;
        const matched = templates.find(
          (template) => template.id === bindingData.templateId,
        );
        if (matched) return matched;
        return {
          id: bindingData.templateId,
          name: bindingData.templateName || "Current Template",
        };
      });
    } else {
      setSelectedTemplate(null);
    }
  }, [bindingData, templates]);

  const MAX_SUGGESTIONS = 10;

  useEffect(() => {
    if (suppressSuggestionsRef.current) {
      suppressSuggestionsRef.current = false;
      return;
    }
    if (isDataSelectorActive && allItems.length > 0 && !searchTerm) {
      setSuggestions(allItems.slice(0, MAX_SUGGESTIONS));
    }
  }, [allItems, isDataSelectorActive, searchTerm]);

  useEffect(() => {
    if (isDataSelectorActive && dataInputRef.current) {
      dataInputRef.current.focus();
      const len = dataInputRef.current.value.length;
      dataInputRef.current.setSelectionRange(len, len);
    }
  }, [isDataSelectorActive]);

  // Keep header showing current binding, but keep input empty so user always starts fresh
  useEffect(() => {
    if (!bindingData) {
      setIsDishSelected(false);
      setSearchTerm("");
      setSelectedRecord(null);
      return;
    }

    // Do not prefill search box or mark a dish as "selected" here;
    // the card uses bindingData.dataRecordName directly.
    setIsDishSelected(false);
    setSearchTerm("");
    setSelectedRecord(null);
  }, [bindingData]);

  // ---------------------------------------------------------
  // 3) Search + Suggestions
  // ---------------------------------------------------------
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsDishSelected(false);
    setSelectedRecord(null);
    hasPromptedRef.current = false;

    if (!value) {
      setSuggestions(allItems.slice(0, MAX_SUGGESTIONS));
      return;
    }

    const filtered = allItems
      .filter((item) => {
        const name = (
          item.identifier ||
          (item.values?.dishName ?? "")
        ).toLowerCase();
        return name.includes(value.toLowerCase());
      })
      .slice(0, MAX_SUGGESTIONS);
    setSuggestions(filtered);
  };

  const handleFocus = () => {
    setSuggestions(allItems.slice(0, MAX_SUGGESTIONS));
    setIsDishSelected(false);
  };

  const handleSelect = (item) => {

    setSearchTerm(item.identifier || item.values?.dishName || "");
    setSuggestions([]);
    setSelectedRecord(item);
    setIsDishSelected(true);
    if (!advancedMode) return;
    hasPromptedRef.current = false;
    // Open form pre-filled for editing
    const initial = {
      identifier: item.identifier || item.values?.dishName || "",
      ...(item.values || {}),
      ...siteData,
    };
    setNewSiteData(initial);
    setSchemaFields(Object.keys(siteData || {}));
    setShowAddForm(true);
  };

  useEffect(() => {
    if (!advancedMode && showAddForm) {
      setShowAddForm(false);
    }
  }, [advancedMode, showAddForm]);

  const handleTemplateSearch = (e) => {
  const value = e.target.value;
  setTemplateSearchTerm(value);
};



  const handleTemplateSelect = (template) => {
    setSelectedTemplate(template);
    setTemplateSearchTerm(template.name || "");
    setTemplateSuggestions([]);
    setIsTemplateInputSelected(true);
    hasPromptedRef.current = false;
  };

  const toggleSelector = (mode) => {
    if (mode === "data") {
      setIsDataSelectorActive((prev) => !prev);
      return;
    }
    setIsTemplateSelectorActive((prev) => !prev);
  };

  const changeModeCardClass = (isActive) =>
    `small-card ${isActive ? "small-card-selected" : "small-card-idle"}`;

  useEffect(() => {
    if (selectedTemplate) {
      setIsTemplateInputSelected(true);
    } else {
      setTemplateSearchTerm("");
      setIsTemplateInputSelected(false);
    }
  }, [selectedTemplate]);

  const bindSelectedRecordToTag = async () => {
    if (!selectedRecord)
      return setUiMessage({
        type: "info",
        text: "Please select a dish first.",
      });

    if (!bindingData?.digitalTagId)
      return setUiMessage({
        type: "error",
        text: "Tag not ready. Cannot bind.",
      });

    const selectedRecordId = selectedRecord?.id;
    const isTemporarySelectedRecordId =
      typeof selectedRecordId === "string" &&
      selectedRecordId.startsWith("new-");

    if (isTemporarySelectedRecordId)
      return setUiMessage({
        type: "error",
        text: "Please save successfully before binding. Temporary records cannot be bound.",
      });

    const dynamicDataId =
      selectedRecordId || bindingData?.dynamicDataId || bindingData?.dataRecordId;

    setIsBindingRequestRunning(true);
    setUiMessage({ type: "info", text: "Binding data to tag..." });

    try {
      const payload = {
        tenantId,
        siteId,
        digitalTagIds: [bindingData.digitalTagId],
        dynamicDataId,
        templateId: selectedTemplate?.id || bindingData.templateId,
      };

      await callPiggybackAPI(
        "digitalTag/bindTemplateData",
        {},
        payload,
        "POST",
      );

      setUiMessage({
        type: "success",
        text: "Record bound to tag successfully.",
      });

      // setShowConfirmModal(true);
      await refreshDigitalTagNow();
    } catch (err) {
      setUiMessage({ type: "error", text: "Failed to bind record." });
    } finally {
      setIsBindingRequestRunning(false);
    }
  };
  const swipeHandlers = useSwipeable({
    onSwiping: (eventData) => {
      if (!isBindingRequestRunning && !isRefreshRunning) {
        // Only track right swipes (positive deltaX)
        if (eventData.deltaX > 0) {
          // Calculate progress based on swipe distance (0 to 100%)
          const swipeDistance = eventData.deltaX;
          const buttonElement = swipeButtonRef.current;

          if (buttonElement) {
            const buttonWidth = buttonElement.offsetWidth;
            const thumbWidth = 44;
            const maxOffset = Math.max(buttonWidth - thumbWidth, 0);
            const thumbOffset = Math.min(Math.max(swipeDistance, 0), maxOffset);
            setSwipeThumbOffset(thumbOffset);
            // Calculate progress, allowing swipe to go slightly beyond 100% for better UX
            const progress = Math.min(
              Math.max((swipeDistance / buttonWidth) * 100, 0),
              120,
            );
            setSwipeProgress(progress);
          } else {
            // Fallback: estimate progress based on typical button width (300px) if ref not available
            const estimatedWidth = 300;
            const progress = Math.min(
              Math.max((swipeDistance / estimatedWidth) * 100, 0),
              120,
            );
            setSwipeProgress(progress);
            const thumbWidth = 44;
            const maxOffset = Math.max(estimatedWidth - thumbWidth, 0);
            const thumbOffset = Math.min(Math.max(swipeDistance, 0), maxOffset);
            setSwipeThumbOffset(thumbOffset);
          }
        } else if (eventData.deltaX < 0) {
          // Reset if swiping left
          setSwipeProgress(0);
          setSwipeThumbOffset(0);
        }
      }
    },
    onSwipedRight: (eventData) => {
      if (!isBindingRequestRunning && !isRefreshRunning) {
        const buttonElement = swipeButtonRef.current;
        const swipeDistance = eventData.deltaX;

        let shouldTrigger = false;

        if (buttonElement) {
          const buttonWidth = buttonElement.offsetWidth;
          const threshold = buttonWidth * 0.6; // 60% of button width
          const thumbWidth = 44;
          const maxOffset = Math.max(buttonWidth - thumbWidth, 0);

          // If swiped more than 60% of the width, consider it complete
          if (swipeDistance >= threshold) {
            shouldTrigger = true;
            setSwipeThumbOffset(maxOffset);
          }
        } else {
          // Fallback: if button ref not available, use absolute distance (200px minimum)
          const minSwipeDistance = 200;
          if (swipeDistance >= minSwipeDistance) {
            shouldTrigger = true;
            const thumbWidth = 44;
            const maxOffset = Math.max(300 - thumbWidth, 0);
            setSwipeThumbOffset(
              Math.min(Math.max(swipeDistance, 0), maxOffset),
            );
          }
        }

        if (shouldTrigger) {
          setSwipeProgress(100);
          setTimeout(() => {
            onSwipeAction(); // triggers bindSelectedRecordToTag()
            setSwipeProgress(0);
            setSwipeThumbOffset(0);
          }, 300);
        } else {
          // Reset if not swiped enough
          setTimeout(() => setSwipeProgress(0), 200);
          setSwipeThumbOffset(0);
        }
      } else {
        setSwipeProgress(0);
        setSwipeThumbOffset(0);
      }
    },
    onSwipedLeft: () => {
      // Reset progress if swiped left
      setTimeout(() => setSwipeProgress(0), 200);
      setSwipeThumbOffset(0);
    },
    preventScrollOnSwipe: true,
    trackMouse: true, // enables swipe using mouse too (very useful for testing)
    trackTouch: true,
    delta: 10, // minimum distance for a swipe
  });

  const formSwipeHandlers = useSwipeable({
    onSwiping: (eventData) => {
      if (!isRefreshRunning) {
        if (eventData.deltaX > 0) {
          const swipeDistance = eventData.deltaX;
          const buttonElement = formSwipeButtonRef.current;

          if (buttonElement) {
            const buttonWidth = buttonElement.offsetWidth;
            const thumbWidth = 44;
            const maxOffset = Math.max(buttonWidth - thumbWidth, 0);
            const thumbOffset = Math.min(Math.max(swipeDistance, 0), maxOffset);
            setFormSwipeThumbOffset(thumbOffset);
            const progress = Math.min(
              Math.max((swipeDistance / buttonWidth) * 100, 0),
              120,
            );
            setFormSwipeProgress(progress);
          } else {
            const estimatedWidth = 300;
            const progress = Math.min(
              Math.max((swipeDistance / estimatedWidth) * 100, 0),
              120,
            );
            setFormSwipeProgress(progress);
            const thumbWidth = 44;
            const maxOffset = Math.max(estimatedWidth - thumbWidth, 0);
            const thumbOffset = Math.min(Math.max(swipeDistance, 0), maxOffset);
            setFormSwipeThumbOffset(thumbOffset);
          }
        } else if (eventData.deltaX < 0) {
          setFormSwipeProgress(0);
          setFormSwipeThumbOffset(0);
        }
      }
    },
    onSwipedRight: (eventData) => {

      if (!isRefreshRunning) {
        const buttonElement = formSwipeButtonRef.current;
        const swipeDistance = eventData.deltaX;
        let shouldTrigger = false;

        if (buttonElement) {
          const buttonWidth = buttonElement.offsetWidth;
          const threshold = buttonWidth * 0.5;
          const thumbWidth = 44;
          const maxOffset = Math.max(buttonWidth - thumbWidth, 0);

          if (swipeDistance >= threshold) {
            shouldTrigger = true;
            setFormSwipeThumbOffset(maxOffset);
          }
        } else {
          const minSwipeDistance = 150; // 50% of 300px fallback width
          if (swipeDistance >= minSwipeDistance) {
            shouldTrigger = true;
            const thumbWidth = 44;
            const maxOffset = Math.max(300 - thumbWidth, 0);
            setFormSwipeThumbOffset(
              Math.min(Math.max(swipeDistance, 0), maxOffset),
            );
          }
        }

        if (shouldTrigger) {
          setFormSwipeProgress(100);
          setTimeout(() => {
            handleFormSaveAndBrush();
            setFormSwipeProgress(0);
            setFormSwipeThumbOffset(0);
          }, 300);
        } else {
          setTimeout(() => setFormSwipeProgress(0), 200);
          setFormSwipeThumbOffset(0);
        }
      } else {
        setFormSwipeProgress(0);
        setFormSwipeThumbOffset(0);
      }
    },
    onSwipedLeft: () => {
      setTimeout(() => setFormSwipeProgress(0), 200);
      setFormSwipeThumbOffset(0);
    },
    preventScrollOnSwipe: true,
    trackMouse: true,
    trackTouch: true,
    delta: 10,
  });

  const refetchBindingData = async () => {
    if (!mac) return;
    try {
      const response = await callPiggybackAPI(
        "getTagDatabindingbyMacAddress",
        { macAddress: mac },
        {},
        "GET",
      );
      setBindingData(response || null);
      if (response?.siteId) setSiteId(response.siteId);
      if (response?.tenantId) setTenantId(response.tenantId);
    } catch (err) {
      console.error("Failed to refetch binding data:", err);
    }
  };

  const refetchItemsData = async () => {
    if (!siteId || !tenantId) return;
    try {
      const dataResponse = await callPiggybackAPI(
        "data-record",
        { siteId, tenantId },
        {},
        "GET",
      );
      setAllItems(Array.isArray(dataResponse) ? dataResponse : []);
    } catch (err) {
      console.error("Failed to refetch items:", err);
    }
  };

  const refreshDigitalTagNow = async () => {
    if (!bindingData?.digitalTagId)
      return setUiMessage({
        type: "error",
        text: "Cannot refresh. Missing tag.",
      });

    setIsRefreshRunning(true);
    setUiMessage({ type: "info", text: "Refreshing digital tag..." });

    try {

      const payload = { digitalTagIds: [bindingData.digitalTagId] };
      const query = { siteId, tenantId };

      await callPiggybackAPI("digitalTag/refresh", query, payload, "POST");

      // // Refetch both binding data and items to show the latest data
      // await Promise.all([refetchBindingData(), refetchItemsData()]);

      setUiMessage({
        type: "success",
        text: "Digital tag refreshed successfully.",
      });
    } catch {
      setUiMessage({ type: "error", text: "Failed to refresh tag." });
    } finally {
      setIsRefreshRunning(false);
      setShowConfirmModal(false);
    }
  };

  const onSwipeAction = async () => await bindSelectedRecordToTag();

  // Labels for UI header
  const originalDataRecordId =
    bindingData?.dataRecordId || bindingData?.dynamicDataId;

  const currentDataLabel = isBindingLoading
    ? "Loading..."
    : selectedRecord?.identifier ||
    selectedRecord?.values?.dishName ||
    bindingData?.dataRecordName ||
    "";

  const templateLabel = isBindingLoading
    ? "Loading..."
    : selectedTemplate?.name || bindingData?.templateName || "";

  const isTemplateChanged =
    selectedTemplate?.id && selectedTemplate?.id !== bindingData?.templateId;

  const isDataChanged = selectedRecord?.id
    ? selectedRecord.id !== originalDataRecordId
    : false;

  const canSwipe = isDataChanged || isTemplateChanged;
  const swipeProgressClamped = Math.min(Math.max(swipeProgress, 0), 100);
  const formSwipeProgressClamped = Math.min(
    Math.max(formSwipeProgress, 0),
    100,
  );
  const normalizedSearchTerm = (searchTerm || "").trim().toLowerCase();
  const dishExists = allItems.some((item) => {
    const itemName = (item.identifier || item.values?.dishName || "")
      .trim()
      .toLowerCase();
    return itemName && itemName === normalizedSearchTerm;
  });
  const canAddNewDish = advancedMode && normalizedSearchTerm && !dishExists;
  const maskedMac = mac
    ? "*".repeat(Math.max(0, mac.length - 4)) + mac.slice(-4)
    : "";


  const handleApplyCollectoion = async (templateId) => {
    const body = {
      collectionId: selectedCollectionProfile?.id,
      templateId,
      siteId,
      tenantId
    };

    try {
      const apiResponse = await callPiggybackAPI(
        "collections/brush",
        {},
        body,
        "POST"
      );

      if (apiResponse) {
        toast.success("Collection Applied Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(apiResponse, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT });
    }
  };


  const searchedTemplates = templateSearchTerm
  ? templates.filter((template) =>
      (template.name || "")
        .toLowerCase()
        .includes(templateSearchTerm.toLowerCase())
    )
  : templates;

  return (
    <div className="main-container">
      <div className="content-wrapper">
        {/* Header */}
        <div className="main-header">
          <div className="mac-block">
            <p className="mac-display">{maskedMac || ""}</p>
            <p className="mac-sub">
              This is what smart sustainability looks like.
            </p>
          </div>

          <div className="right-header">
            <IconButton
              className="main-icon-btn"
              onClick={handleAccountMenuOpen}
              sx={{ p: 0, borderRadius: "50%" }}
            >
              <img
                src='https://storage.googleapis.com/content_ai_bucket_elhitech/content/truink%20splash%20-%20cropped%20-%20purple.png'
                alt="menu"
                className="main-icon-img"
              />
            </IconButton>
            <Menu
              anchorEl={accountMenuAnchor}
              open={Boolean(accountMenuAnchor)}
              onClose={handleAccountMenuClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <MenuItem
                onClick={handleLogoutRequest}
                sx={{ color: "rgb(87,27,46)", "&:hover": { backgroundColor: "#ecdfe3" } }}
              >
                <ListItemIcon>
                  <LogoutRoundedIcon fontSize="small" sx={{ color: "rgb(87,27,46)" }} />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>

        <div className="inspect-mode-row">
          <div className="advanced-toggle">
            <span className="advanced-text">Inspect Mode</span>
            <label className="switch">
              <input
                type="checkbox"
                aria-label="Advanced mode"
                checked={advancedMode}
                onChange={(e) => setAdvancedMode(e.target.checked)}
              />
              <span className="slider" />
            </label>
          </div>
        </div>

        {/* Change Toggles */}
        <div className="card-grid">
          <div
            role="button"
            className="small-card-toggle"
            onClick={() => toggleSelector("data")}
          >
            <div className={changeModeCardClass(isDataSelectorActive)}>
              <h3 className="small-card-title">Change Data</h3>
              <p className="small-card-sub">{currentDataLabel}</p>
            </div>
          </div>

          <div
            role="button"
            className="small-card-toggle"
            onClick={() => toggleSelector("template")}
          >
            <div className={changeModeCardClass(isTemplateSelectorActive)}>
              <h3 className="small-card-title">Change Template</h3>
              <p className="small-card-sub">{templateLabel}</p>
            </div>
          </div>
        </div>

        {/* Change Data Row */}
        {isDataSelectorActive && (
          <div className="search-section">
            <h3 className="search-card-title">Change Data</h3>
            <div className="search-input-wrapper">
              <input
                type="text"
                ref={dataInputRef}
                className={`search-input ${isDishSelected ? "search-input-selected" : ""
                  }`}
                placeholder="Start typing to search the dishes"
                value={searchTerm}
                onChange={handleSearch}
                onFocus={handleFocus}
              />

              {(suggestions.length > 0 || canAddNewDish) && (
                <div 
                className="suggestion-box"
                >
                  {suggestions.length > 0 ? (
                    suggestions.slice(0, 5).map((item) => (
                      <div
                        key={item.id}
                        className="suggestion-item"
                        onClick={() => handleSelect(item)}
                      >
                        {item.identifier ||
                          item.values?.dishName ||
                          "Unnamed Dish"}
                      </div>
                    ))
                  ) : (
                    <div
                      className="suggestion-item add-suggestion"
                      onClick={handleAddClick}
                    >
                      Add "{searchTerm.trim()}"
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}

        {/* Change Template Row */}
        {isTemplateSelectorActive && (
          <div className="search-section">
            <h3 className="search-card-title">Change Template</h3>
            <div className="search-input-wrapper">
              <input
                type="text"
                className={`search-input ${
                  selectedTemplate ? "search-input-selected" : ""
                }`}
                placeholder="Start typing to search templates"
                value={templateSearchTerm}
                onChange={handleTemplateSearch}
              />

              {templateDropdownOpen && templates.length > 0 && (
                <div
                  className="suggestion-box"
                  style={{
                    maxHeight: "138px",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                    scrollbarColor: "#571B2E transparent",
                  }}
                >
                  {searchedTemplates.map((template) => (
                    <div
                      key={template.id}
                      className="suggestion-item"
                      onClick={() => {
                        handleTemplateSelect(template);
                        setTemplateDropdownOpen(false);
                      }}
                    >
                      {template.name || "Unnamed Template"}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}

        {!advancedMode && !showAddForm && canSwipe && (
          <div
            ref={swipeButtonRef}
            {...swipeHandlers}
            className={`swipe-button ${isBindingRequestRunning || isRefreshRunning ? "disabled" : ""
              }`}
            style={{
              "--swipe-progress": `${swipeProgressClamped}%`,
            }}
          >
            <div
              className="swipe-progress-fill"
              style={{ width: `${swipeProgressClamped}%` }}
            ></div>
            <div
              className="swipe-thumb"
              style={{ transform: `translateX(${swipeThumbOffset}px)` }}
            >
              <span className="swipe-icon">
                <img src={swipeIcon} alt="Swipe" className="swipe-icon-img" />
              </span>
            </div>
            <span className="swipe-label">
              {isBindingRequestRunning
                ? "Binding…"
                : isRefreshRunning
                  ? "Refreshing…"
                  : "Swipe to Update the Tag"}
            </span>
          </div>
        )}

        {uiMessage.text && (
          <div
            style={{
              padding: "10px 14px",
              borderRadius: "8px",
              marginTop: "12px",
              fontWeight: 500,
              textAlign: "center",
              background:
                uiMessage.type === "error"
                  ? "#ffe5e5"
                  : uiMessage.type === "success"
                    ? "#e6ffed"
                    : "#eaf4ff",
              color:
                uiMessage.type === "error"
                  ? "#b00000"
                  : uiMessage.type === "success"
                    ? "#037d32"
                    : "#004089",
              border:
                uiMessage.type === "error"
                  ? "1px solid #ff8c8c"
                  : uiMessage.type === "success"
                    ? "1px solid #96e4ab"
                    : "1px solid #98c4ff",
            }}
          >
            {uiMessage.text}
          </div>
        )}

        {(advancedMode && showAddForm) && (
          <div className="store-settings-screen">
            <div className="store-settings-container">
              <div className="store-settings-header">
                <div className="header-text">
                  <h3>Add / Edit Tag Data</h3>
                  <p>Please confirm the data before updating</p>
                </div>

                <button className="close-btn" onClick={handleFormCancel}>
                  <img src="https://storage.googleapis.com/content_ai_bucket_elhitech/content/Multiply.png" alt="Close" />
                </button>
              </div>
              <div style={{ overflowY: "auto" }}>
                <div className="form-rows">
                  {(schemaFields.length > 0
                    ? schemaFields
                    : Object.keys(newSiteData || {})
                  ).map((key) => (
                    <div className="form-row" key={key}>
                      <input
                        className="form-input"
                        placeholder={key}
                        value={newSiteData[key] ?? ""}
                        onChange={(e) => handleFormChange(key, e.target.value)}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-actions-row">
                <button
                  ref={formSwipeButtonRef}
                  {...formSwipeHandlers}
                  className={`swipe-button btn-save-update ${isRefreshRunning ? "disabled" : ""
                    }`}
                  style={{
                    "--swipe-progress": `${formSwipeProgressClamped}%`,
                  }}
                >
                  <div
                    className="swipe-progress-fill"
                    style={{ width: `${formSwipeProgressClamped}%` }}
                  ></div>
                  <div
                    className="swipe-thumb"
                    style={{ transform: `translateX(${formSwipeThumbOffset}px)` }}
                  >
                    <span className="swipe-icon">
                      <img src={swipeIcon} alt="Swipe" className="swipe-icon-img" />
                    </span>
                  </div>
                  <span className="swipe-label">
                    {isRefreshRunning ? "Refreshing…" : "Save & Brush"}
                  </span>
                </button>

                <button
                  className="btn-save-cancel"
                  onClick={handleFormSaveAndCancel}
                >
                  Save & Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>



      {
        showTagSearch && (
          <Box className="store-settings-screen">
            <Box
              className="store-settings-container"
              sx={{
                width: { xs: "96vw", sm: "720px" },
                maxWidth: "95vw",
                p: { xs: 2, sm: 3 },
                borderRadius: { xs: "14px", sm: "18px" },
                m: "auto",
                maxHeight: "90vh",
                overflow: "hidden"
              }}
            >
              <Box
                className="store-settings-header"
                sx={{
                  mb: "14px",
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 1.5
                }}
              >
                <Box className="header-text" sx={{ minWidth: 0, flex: 1 }}>
                  <Typography
                    component="h3"
                    sx={{
                      fontSize: { xs: "22px", sm: "28px" },
                      m: 0,
                      lineHeight: 1.2,
                      wordBreak: "break-word"
                    }}
                  >
                    Search Tag by Name
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "14px", sm: "15px" },
                      mt: "6px"
                    }}
                  >
                    Type to find a tag
                  </Typography>
                </Box>

                <IconButton
                  className="close-btn"
                  onClick={closeTagSearch}
                  sx={{
                    width: { xs: 38, sm: 42 },
                    height: { xs: 38, sm: 42 },
                    flexShrink: 0,
                    color: "rgb(87,27,46)"
                  }}
                >
                  <CloseRoundedIcon sx={{ fontSize: { xs: 24, sm: 28 } }} />
                </IconButton>
              </Box>

              <Box sx={{ mt: 1.5 }}>
                <Box className="search-input-wrapper" sx={{ position: "relative" }}>
                  <TextField
                    fullWidth
                    type="text"
                    placeholder="Search tag name..."
                    value={tagSearchTerm}
                    onChange={handleTagSearchChange}
                    autoFocus
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchRoundedIcon
                            sx={{
                              fontSize: { xs: 24, sm: 32 },
                              color: "rgb(87,27,46)"
                            }}
                          />
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        height: { xs: 48, sm: 54 },
                        borderRadius: "10px",
                        fontSize: { xs: "15px", sm: "16px" },
                        "& fieldset": {
                          border: "2px solid rgb(87,27,46)"
                        },
                        "&:hover fieldset": {
                          border: "2px solid rgb(87,27,46)"
                        },
                        "&.Mui-focused fieldset": {
                          border: "2px solid rgb(87,27,46)"
                        }
                      }
                    }}
                  />

                  {(isTagSearchLoading || tagSearchResults.length > 0) && (
                    <Box
                      className="suggestion-box"
                      sx={{
                        mt: "14px",
                        borderRadius: "8px",
                        maxHeight: { xs: "45vh", sm: "400px" },
                        overflowY: "auto"
                      }}
                    >
                      {isTagSearchLoading ? (
                        <Box
                          className="suggestion-item"
                          sx={{
                            color: "#888",
                            fontSize: "15px",
                            p: { xs: "10px", sm: "12px" }
                          }}
                        >
                          Searching...
                        </Box>
                      ) : (
                        tagSearchResults.map((tag) => (
                          <Box
                            key={tag.id}
                            className="suggestion-item"
                            onClick={() => {
                              handleTagSelect(tag);
                              setActive(-1)
                            }}
                            sx={{
                              p: { xs: "10px", sm: "12px" },
                              borderRadius: "10px",
                              fontSize: { xs: "14px", sm: "15px" },
                              cursor: "pointer",
                              overflow: "hidden"
                            }}
                          >
                            <Box
                              component="strong"
                              sx={{ fontSize: { xs: "15px", sm: "16px" } }}
                            >
                              {tag.name}
                            </Box>

                            <Box
                              component="span"
                              sx={{
                                fontSize: { xs: "12px", sm: "13px" },
                                color: "#888",
                                ml: 1,
                                wordBreak: "break-all"
                              }}
                            >
                              {tag.macAddress}
                            </Box>
                          </Box>
                        ))
                      )}
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        )
      }
      <RecordDetailsModal
        open={(dataTableOpen && !((advancedMode || dataTableOpen) && showAddForm))}
        records={allItems}
        onClose={() => {
          setDataTableOpen(false)
          setActive(-1);
        }}
        actions={[
          {
            name: "View",
            icon: <RemoveRedEyeIcon fontSize="small" />,
            onClick: (record) => {
              setDataTableOpen(false);
              setSelectedRecordForView(record)
              setActive(-1);
            }
          },
          {
            name: "Edit",
            icon: <ModeEditIcon fontSize="small" />,
            onClick: (record) => {
              setActive(-1);
              handleSelect(record);
            }
          },
        ]}
      />

      <RecordDetailsModal
        open={collectionsTableOpen}
        records={collections}
        onClose={() => {
          setDataTableOpen(false)
          setCollectionTableOpen(false)
          setActive(-1);
        }}
        heading="Collections Data"
        actions={[
          {
            name: "View",
            icon: <RemoveRedEyeIcon fontSize="small" />,
            onClick: (record) => {
              setDataTableOpen(false);
              setSelectedCollection(record)
              setActive(-1);
            }
          },
          {
            name: "Apply Collection Profile",
            icon: <BrushIcon fontSize="small" />,
            onClick: (record) => {
              setDataTableOpen(false);
              setSelectedCollectionProfile(record)
              setActive(-1);
            }
          },
        ]}
      />

      <TrueInkCollectionProfileModal
        open={selectedCollectionProfile?.id}
        onClose={() => setSelectedCollectionProfile({})}
        templates={templates}
        onSave={handleApplyCollectoion}
      />

      <MobileViewCollectionModal
        open={selectedCollecion?.id}
        collection={selectedCollecion}
        onClose={() => setSelectedCollection({})}
      />

      <MobileViewDataModal
        open={selectedRecordForView?.id}
        data={selectedRecordForView}
        onClose={() => {
          setDataTableOpen(true);
          setSelectedRecordForView({});
        }}
      />

      <TruinkMobileDock
        active={active}
        setActive={(val) => {
          if (showAddForm) {
            setShowAddForm(false)
          }
          setActive(val);
          if (val === 0) {
            openTagSearch(true);
            setDataTableOpen(false)
            setCollectionTableOpen(false)
          }
          else if (val == 1) {
            setAdvancedMode(true)
            openTagSearch(false);
            setDataTableOpen(true)
            setCollectionTableOpen(false)
          }
          else if (val == 2) {
            openTagSearch(false);
            setDataTableOpen(false)
            setCollectionTableOpen(true)
          }
        }}
      />

      <Dialog open={logoutConfirmOpen} onClose={() => setLogoutConfirmOpen(false)}>
        <DialogTitle sx={{ color: "rgb(87,27,46)", fontWeight: 700 }}>Log out?</DialogTitle>
        <DialogContent>
          <Typography sx={{ color: "#5a1c2f" }}>Are you sure you want to log out of this device?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setLogoutConfirmOpen(false)} sx={{ color: "#5a1c2f" }}>
            Cancel
          </Button>
          <Button
            onClick={handleLogoutConfirm}
            variant="contained"
            disableElevation
            sx={{
              backgroundColor: "rgb(87,27,46)",
              "&:hover": { backgroundColor: "#6b2048" },
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}

export default MobileMain;
